import * as grpcWeb from 'grpc-web';
import { Product, DisplayProduct } from "../components/suppliers/product";
import { convertErrorMessage, getAuthMetadata } from '../helpers/rpc';
import { DavidsonsProduct as DavidsonsProductPb, GetDavidsonsProductRequest } from '../rpc/admin/davidsons_pb';
import { SearchRequest, Hit, SearchResponse } from '../rpc/admin/search_pb';
import { Supplier } from '../rpc/admin/suppliers_pb';
import { AdminServiceClient } from '../rpc/admin/AdminServiceClientPb';
import { getBaseApiUrl } from '../helpers/instance';
import { getUser } from '../helpers/user';
import { logOut } from '../helpers/login';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import React, { Component } from 'react';

interface MatchParams {
    id: string;
}

interface DavidsonsProps {}

interface DavidsonsState {
    product?: DisplayProduct;
    supplierProducts: Hit[];
    errorMessage: string;
}

class DavidsonsProduct extends Component<DavidsonsProps & RouteComponentProps<MatchParams>, DavidsonsState> {

    constructor(props: DavidsonsProps & RouteComponentProps<MatchParams>) {
        super(props);
        this.state = {
            supplierProducts: [],
            errorMessage: ''
        };
    }

    private updateProduct(product: DavidsonsProductPb) {
        const displayProduct = new DisplayProduct();
        displayProduct.supplier = Supplier.SUPPLIER_DAVIDSONS;
        displayProduct.sku = product.getItemNumber();
        displayProduct.title = product.getItemDescription();
        displayProduct.manufacturer = product.getManufacturer();
        displayProduct.price = product.getDealerPrice() * 100;
        displayProduct.mapp = product.getMinPrice() * 100;
        displayProduct.msrp = product.getRetailPrice() * 100;
        displayProduct.images = product.getImagesList();
        displayProduct.qoh = product.getQuantity();

        Product.maybeAddStringAttribute(displayProduct, 'UPC', product.getUpcCode());
        Product.maybeAddStringAttribute(displayProduct, 'Model Series', product.getModelSeries());
        Product.maybeAddStringAttribute(displayProduct, 'Gun Type', product.getGunType());
        Product.maybeAddStringAttribute(displayProduct, 'Action', product.getAction());
        Product.maybeAddStringAttribute(displayProduct, 'Capacity', product.getCapacity());
        Product.maybeAddStringAttribute(displayProduct, 'Caliber', product.getCaliber());
        Product.maybeAddStringAttribute(displayProduct, 'Finish', product.getFinish());
        Product.maybeAddStringAttribute(displayProduct, 'Stock', product.getStock());
        Product.maybeAddStringAttribute(displayProduct, 'Sights', product.getSights());
        Product.maybeAddStringAttribute(displayProduct, 'Features', product.getFeatures());
        Product.maybeAddStringAttribute(displayProduct, 'Magazine Capacity', product.getMagCapacity());
        Product.addNumberAttribute(displayProduct, 'Barrel Length', product.getBarrelLength());
        Product.addNumberAttribute(displayProduct, 'Overall Length', product.getOverallLength());
        Product.addNumberAttribute(displayProduct, 'QOH Arizona', product.getQuantityAz());
        Product.addNumberAttribute(displayProduct, 'QOH North Carolina', product.getQuantityNc());
        Product.maybeAddStringAttribute(displayProduct, 'Sale Ends', product.getSaleEnds());
        if (product.getSaleEnds()) {
            Product.addNumberAttribute(displayProduct, 'Sale Price', product.getSalePrice());
        }

        this.setState({
            product: displayProduct,
        })
    }

    componentDidMount() {
        if (!getUser()) {
            logOut();
            return;
        }

        let itemNumber: string;
        const id = this.props.match.params.id;
        if (typeof id === 'string') {
            itemNumber = id;
        } else {
            this.setState({
                errorMessage: 'Product not found',
            });
            return;
        }

        this.setState({
            errorMessage: '',
        });

        const client = new AdminServiceClient(getBaseApiUrl(), null, null);
        const request = new GetDavidsonsProductRequest();
        request.setItemNumber(itemNumber);
        client.getDavidsonsProduct(request, getAuthMetadata(), (err: grpcWeb.Error, response: DavidsonsProductPb) => {
            if (!err) {
                this.updateProduct(response);

                if (response.getUpcCode()) {
                    const searchRequest = new SearchRequest();
                    searchRequest.setQuery(response.getUpcCode());
                    client.supplierSearch(searchRequest, getAuthMetadata(), (err: grpcWeb.Error, searchResponse: SearchResponse) => {
                        if (!err) {
                            const hits: Hit[] = [];
                            searchResponse.getHitsList().forEach((hit) => {
                                if (hit.getSupplier() !== Supplier.SUPPLIER_DAVIDSONS) {
                                    hits.push(hit);
                                }
                            });
                            this.setState({
                                supplierProducts: hits,
                            });
                        } else {
                            this.setState({
                                errorMessage: convertErrorMessage(err),
                            });
                            console.error('while searching suppliers: ' + err);
                        }
                    });
                }
            } else {
                if (err.code === grpcWeb.StatusCode.UNAUTHENTICATED || err.code === grpcWeb.StatusCode.PERMISSION_DENIED) {
                    logOut();
                } else {
                    this.setState({
                        errorMessage: convertErrorMessage(err),
                    });
                    console.error(err);
                }
            }
        });
    }

    render() {
        if (!getUser()) {
            return <div>Redirecting...</div>;
        }
        if (this.state.product) {
            const originals = Product.originalImages('suppliers/davidsons', this.state.product.images)
            const images = Product.pruneImages(originals);
            return <Product product={this.state.product}
                images={images}
                errorMessage={this.state.errorMessage}
                supplierProducts= {this.state.supplierProducts}
                imagePrefix='suppliers/davidsons'
                manufacturerFilterPrefix='/davidsons?f=manufacturer' />
        }
        return <></>;
    }
}

export default withRouter(DavidsonsProduct);
